import React from 'react';
import { IconButton, Paper, Typography } from '@material-ui/core';
import { Add as AddIcon, Remove as RemoveIcon } from '@material-ui/icons';

export interface ProductBoardColumnActionsProps {
  headerCollapsed?: boolean;
  collapsed?: boolean;
  hideHeader?: boolean;
  onToggle?: () => void;
  onToggleAll?: () => void;
}

const ProductBoardColumnActions: React.FC<ProductBoardColumnActionsProps> = (
  props: ProductBoardColumnActionsProps
) => {
  const {
    collapsed = false,
    hideHeader = false,
    headerCollapsed = false,
    onToggle,
    onToggleAll
  } = props;

  return (
    <Paper elevation={0} className='column actions'>
      {!hideHeader && (
        <div className='column-header expand-collapse'>
          <IconButton
            size='small'
            onClick={onToggleAll}
            className={headerCollapsed ? 'btn-expand' : 'btn-collapse'}
          >
            {headerCollapsed ? <AddIcon /> : <RemoveIcon />}
          </IconButton>
          {/* to match ProductBoardColumn header height */}
          <Typography variant='overline' className='title'>
            &nbsp;
          </Typography>
        </div>
      )}
      <Paper elevation={1} className='card-container'>
        <IconButton
          size='small'
          onClick={onToggle}
          className={collapsed ? 'btn-expand' : 'btn-collapse'}
        >
          {collapsed ? <AddIcon /> : <RemoveIcon />}
        </IconButton>
      </Paper>
    </Paper>
  );
};

export default ProductBoardColumnActions;
